import {useAuthUser} from 'react-auth-kit'
import {useLang} from 'src/app/modules/i18n/Metronici18n'

const CAMPAIGN_URL = process.env.REACT_APP_CAMPAIGN_UI_URL

export default function Campaign() {
  const authUser = useAuthUser()
  const currentDateTime = new Date().toISOString()
  const currentLang = useLang()

  return (
    <div className='card rounded-0 w-100 h-100'>
      <div className='h-100'>
        <iframe
          title='Promo'
          src={`${CAMPAIGN_URL}/dashboard?userID=${
            authUser().id
          }&v=${currentDateTime}&parentUrl=${window.location.origin}&token=${
            authUser().token
          }&timestamp=${new Date().getTime()}&lang=${currentLang}`}
          width='100%'
          className='h-100 border-0'
        ></iframe>
      </div>
    </div>
  )
}
